import React from "react";
import { Route, Routes } from "react-router-dom";
import { notification } from "antd";
import { useClient } from "../Context/ClientContext";
import { NotificationPlacement } from "antd/es/notification/interface";
import DashboardTemplate from "../Template/DashboardTemplate";
import InventoryDashboard from "../Pages/Inventory/InventoryDashboard";
import RequisitionDashboard from "../Pages/Inventory/RequisitionDashboard";
import VendorDetailsTable from "../Pages/Inventory/VendorsDetails/VendorDetailsTable";
import VendorTabs from "../Pages/Inventory/VendorsDetails/VendorTabs";
import BidsDetails from "../Pages/Inventory/Bids/BidsDetails";
import AddBids from "../Pages/Inventory/Bids/AddBids";
import BidTabbtn from "../Pages/Inventory/Bids/BidTabbtn";
import InventoryMaster from "../Pages/Inventory/InventoryMaster/InventoryMaster";
import VendorRegRequest from "../Pages/Inventory/VendorRegRequest/VendorRegRequest";

export type NotificationType = "success" | "info" | "warning" | "error";
export const notificationContext = React.createContext<any>({});

const InventoryPageRoute = () => {
  const { currentClient, estimatehide } = useClient();
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (
    type: NotificationType,
    message: string,
    description?: string,
    duration?: number,
    closeIcon?: boolean,
    placement?: NotificationPlacement,
    icon?: any
  ) => {
    api[type]({
      message: message,
      description: description,
      duration: duration ? duration : 4,
      // closeIcon: closeIcon ? false : <CloseOutlined  />,
      style: {
        marginTop: "23px",
        padding: "15px 12px 7px 15px",
      },
      placement: placement,
      icon: icon,
    });
  };

  return (
    <notificationContext.Provider value={{ openNotification }}>
      <>
        {/* <React.Suspense fallback={<FullPageSpinner />}> */}
        <Routes>
          {/*  -----Inventory Dashboard Route -----*/}
          <Route
            path={`${currentClient?.id}/inventory-Dashboard`}
            element={
              <DashboardTemplate
                element={<InventoryDashboard />}
                breadcrumprops={[
                  {
                    item: "Client",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Inventory",
                  },
                ]}
              />
            }
          />
          <Route
            path={`${currentClient?.id}/requisition`}
            element={
              <DashboardTemplate
                element={<RequisitionDashboard />}
                breadcrumprops={[
                  {
                    item: "Client",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Requisition",
                  },
                ]}
              />
            }
          />
          <Route
            path={`${currentClient?.id}/vendor`}
            element={
              <DashboardTemplate
                element={<VendorDetailsTable />}
                breadcrumprops={[
                  {
                    item: "Client",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Vendor",
                  },
                ]}
              />
            }
          />

          <Route
            path={`${currentClient?.id}/vendor/vendorDetails`}
            element={
              <DashboardTemplate
                element={<VendorTabs />}
                breadcrumprops={[
                  {
                    item: "Client",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Vendor",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          />

          <Route
            path={`${currentClient?.id}/bids`}
            element={
              <DashboardTemplate
                element={<BidsDetails />}
                breadcrumprops={[
                  {
                    item: "Client",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Bids",
                  },
                ]}
              />
            }
          />

          <Route
            path={`${currentClient?.id}/bids/add`}
            element={
              <DashboardTemplate
                element={<AddBids />}
                breadcrumprops={[
                  {
                    item: "Client",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Bids",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          />
          <Route
            path={`${currentClient?.id}/bids/info`}
            element={
              <DashboardTemplate
                element={<BidTabbtn />}
                breadcrumprops={[
                  {
                    item: "Client",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Bids",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Info",
                  },
                ]}
              />
            }
          />

          <Route
            path={`${currentClient?.id}/inventoryMaster`}
            element={
              <DashboardTemplate
                element={<InventoryMaster />}
                breadcrumprops={[
                  {
                    item: "Client",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Inventory Master",
                  },
                ]}
              />
            }
          />
          <Route
            path={`${currentClient?.id}/vendorRegistrationReq`}
            element={
              <DashboardTemplate
                element={<VendorRegRequest />}
                breadcrumprops={[
                  {
                    item: "Client",
                    path: `/accounts/clients/${currentClient?.id}/dashboard`,
                  },
                  {
                    item: "Vendor Registration Request",
                  },
                ]}
              />
            }
          />
        </Routes>
      </>
    </notificationContext.Provider>
  );
};

export default InventoryPageRoute;
